import axios from "axios";
const axiosApi = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});

axiosApi.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("authorize_api_token");
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    } else {
      delete config.headers["Authorization"];
      config.headers["WTICoreApiInternalKey"] = process.env.REACT_APP_INTERNAL_API_KEY || "ecbe5542-24ce-40bb-b0dc-2a016a1a7904";
    }
    return config;
  },
  (error) => Promise.reject(error),
);

const TOKEN_URL = "/authorize/token";
// Parallel calls that hit 401 together share one refresh instead of each fetching a token.
let refreshPromise = null;

axiosApi.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    const isTokenCall = (originalRequest?.url || "").includes(TOKEN_URL);
    if (error.response?.status === 401 && originalRequest && !originalRequest._retry && !isTokenCall) {
      originalRequest._retry = true;
      const token = await refreshAccessToken();
      if (token) originalRequest.headers.Authorization = `Bearer ${token}`;
      return axios(originalRequest);
    }
    return Promise.reject(error);
  },
);

function refreshAccessToken() {
  if (!refreshPromise) {
    localStorage.removeItem("authorize_api_token");
    refreshPromise = axiosApi
      .post(TOKEN_URL, { SecretKey: process.env.REACT_APP_API_SECRET_KEY })
      .then((res) => {
        if (res.status === 200 && res.data) {
          localStorage.setItem("authorize_api_token", res.data);
          return res.data;
        }
        return null;
      })
      .catch(() => null)
      .finally(() => { refreshPromise = null; });
  }
  return refreshPromise;
}
export default axiosApi;
export const setupInterceptors = (setIsNetworkError) => {
  axiosApi.interceptors.response.use(
    (response) => {
      // ✅ API reachable again
      setIsNetworkError(false);
      return response;
    },
    (error) => {
      // ❌ No response = network/server down
      if (!error.response) {
        setIsNetworkError(true);
        return Promise.reject(error);
      }

      const status = error.response.status;

      // ❌ Trigger full-page error only for server errors
      // if (status >= 500) {
      //   setIsNetworkError(true);
      // }

      return Promise.reject(error);
    },
  );
};
